import { render, staticRenderFns } from "./CheckoutDetailsHeaderTemplate.vue?vue&type=template&id=22a0fc60&scoped=true&"
import script from "./CheckoutDetailsHeaderTemplate.vue?vue&type=script&lang=js&"
export * from "./CheckoutDetailsHeaderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDetailsHeaderTemplate.vue?vue&type=style&index=0&id=22a0fc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0fc60",
  null
  
)

export default component.exports